// web/src/api/terms/TermsAPI.ts
import {
  PendingTermsAgreementTypes,
  TermsAgreementTypes,
  TermsListTypes,
} from '@/pages/TermsAgreement/store/types';
import { AxiosInstance, AxiosResponse } from 'axios';

export default class TermsAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getTermsAgreementCount(): Promise<
    AxiosResponse<{ data: TermsAgreementTypes }>
  > {
    return this.client.get<{ data: TermsAgreementTypes }>(
      '/v2/company/entities/terms-count/',
    );
  }

  async getTermsAgreement(): Promise<
    AxiosResponse<{ data: PendingTermsAgreementTypes[] }>
  > {
    return this.client.get<{ data: PendingTermsAgreementTypes[] }>(
      '/v2/company/entities/terms-pending',
    );
  }

  async getTermsList(): Promise<AxiosResponse<{ data: TermsListTypes[] }>> {
    return this.client.get<{ data: TermsListTypes[] }>('/v2/terms/');
  }

  async downloadTerm(id: number): Promise<AxiosResponse> {
    return this.client.get(`/v2/terms/${id}/download-url/`);
  }

  async termsAgreementAccept({
    id,
  }: {
    id: string;
  }): Promise<AxiosResponse<void>> {
    return this.client.post<void>(`/v2/company/entities/${id}/agree-terms/`);
  }
}
